import type { HomeHeroMedia } from "../../content/siteContent";
import type { ViewportTier } from "../../lib/viewport";

export const studioImagePlanePosition: [number, number, number] = [0, 0.1, -0.08];
export const studioImagePlaneScale: [number, number, number] = [9, 5, 1];
export const mobileStudioImagePlanePosition: [number, number, number] = [-0.1, 0, 0];
export const mobileStudioImagePlaneScale: [number, number, number] = [3, 2, 1];

export function getStudioImageLayout(viewport: ViewportTier = "desktop") {
  return viewport === "mobile"
    ? {
        position: mobileStudioImagePlanePosition,
        scale: mobileStudioImagePlaneScale
      }
    : {
        position: studioImagePlanePosition,
        scale: studioImagePlaneScale
      };
}

export function getStudioImageFocalPoint(
  focalPoint: HomeHeroMedia["focalPoint"],
  zOffset = 0,
  viewport: ViewportTier = "desktop"
): [number, number, number] {
  const { position, scale } = getStudioImageLayout(viewport);
  const normalizedX = (focalPoint.x - 50) / 50;
  const normalizedY = (50 - focalPoint.y) / 50;

  return [
    position[0] + normalizedX * scale[0] * 0.5,
    position[1] + normalizedY * scale[1] * 0.5,
    position[2] + zOffset
  ];
}
